var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipper-detail"},[_c('enterprise',{attrs:{"form":_vm.form,"loading":_vm.loading}}),_c('fix-boottom',[_c('template',{slot:"button"},[_c('el-button',{on:{"click":_vm.onReturn}},[_vm._v(" 返回 ")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }